"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4784],{

/***/ 98836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ LayerIdentifier; }
/* harmony export */ });
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63964);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36886);



function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  w-4\n  h-4\n  bg-opacity-40\n  border\n  rounded\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        "50;\n  border-color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var LayerIdentifier = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_0___default().div(_templateObject())).withConfig({
    componentId: "sc-ad73666-0"
})(_templateObject1(), function(param) {
    var $id = param.$id;
    return (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getLayerColor */ .o)($id);
}, function(param) {
    var $id = param.$id;
    return (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getLayerColor */ .o)($id);
});


/***/ }),

/***/ 48151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ LayersControl; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/leaflet/dist/leaflet-src.js
var leaflet_src = __webpack_require__(15623);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../../node_modules/react-leaflet/esm/hooks.js
var hooks = __webpack_require__(89507);
// EXTERNAL MODULE: ../../node_modules/tailwind-styled-components/dist/index.js
var dist = __webpack_require__(17471);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(33052);
// EXTERNAL MODULE: ../../node_modules/react-collapse/lib/index.js
var lib = __webpack_require__(98452);
// EXTERNAL MODULE: ../core/src/components/Inputs/CheckBox.tsx
var CheckBox = __webpack_require__(76008);
// EXTERNAL MODULE: ../core/src/components/SvgIcon.tsx
var SvgIcon = __webpack_require__(16283);
// EXTERNAL MODULE: ../core/src/contexts/Layers.tsx
var Layers = __webpack_require__(95106);
// EXTERNAL MODULE: ../core/src/components/Maps/Controls/LayersControl/LayerIdentifier.tsx
var LayerIdentifier = __webpack_require__(98836);
;// CONCATENATED MODULE: ../assets/icons/map-chevron.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgMapChevron = function SvgMapChevron(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M7.14 5.996c0-.34-.134-.643-.403-.906L1.887.313A1.042 1.042 0 0 0 1.12 0C.813 0 .55.107.33.321.11.535 0 .796 0 1.104c0 .307.12.579.362.815L4.53 5.988.362 10.073c-.241.236-.362.508-.362.815 0 .308.11.57.33.787.22.217.483.325.79.325.302 0 .557-.107.766-.321l4.851-4.777c.143-.143.246-.287.309-.433.063-.145.095-.303.095-.473Z",
    fill: "#999"
  })));
};

/* harmony default export */ var map_chevron = (SvgMapChevron);
;// CONCATENATED MODULE: ../core/src/components/Maps/Controls/LayersControl/NestedListItem.tsx









function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "h-full flex items-center px-2 border-r border-gray-400"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  border-b\n  border-gray-400\n  h-9\n  flex\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  flex\n  flex-1\n  items-center\n  pr-2\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex\n  items-center\n  justify-center\n  min-w-[16px]\n  min-h-[16px]\n  transition-all\n  duration-300\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var BoxContainer = dist_default().div(_templateObject());
var Line = dist_default().div(_templateObject1(), function(param) {
    var $child = param.$child;
    return $child ? 'bg-gray-200' : 'bg-white';
});
var TitleContainer = dist_default().div(_templateObject2(), function(param) {
    var $child = param.$child;
    return $child ? 'pl-8' : 'pl-2';
}, function(param) {
    var $clickable = param.$clickable;
    return $clickable ? 'cursor-pointer' : '';
});
var IconContainer = dist_default().div(_templateObject3(), function(param) {
    var $open = param.$open;
    return $open ? 'rotate-90' : '';
});
var ListItem = function(param1) {
    var title = param1.title, id1 = param1.id, items = param1.items, child = param1.child, toggleCollapse = param1.toggleCollapse, open = param1.open;
    var ref = (0,react.useContext)(Layers/* default */.Z), selected = ref.selected, toggleSelected = ref.toggleSelected;
    var hasItems = !!(items === null || items === void 0 ? void 0 : items.length);
    var selectedCount = selected.filter(function(id) {
        return items === null || items === void 0 ? void 0 : items.find(function(item) {
            return item.id === id;
        });
    }).length;
    var checked = hasItems ? selectedCount === items.length : selected.includes(id1);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
        $child: child,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* CheckBox */.J, {
                    name: id1,
                    onChange: function() {
                        return toggleSelected(hasItems ? items.map(function(param) {
                            var id = param.id;
                            return id;
                        }) : [
                            id1
                        ]);
                    },
                    checked: checked,
                    indeterminate: hasItems && !checked && selectedCount > 0
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleContainer, {
                $child: child,
                $clickable: !!(items === null || items === void 0 ? void 0 : items.length),
                onClick: toggleCollapse,
                children: [
                    (items === null || items === void 0 ? void 0 : items.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                        $open: open,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                            src: map_chevron,
                            size: 12
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LayerIdentifier/* LayerIdentifier */.X, {
                        $id: id1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-2",
                        children: title
                    })
                ]
            })
        ]
    }));
};
var NestedListItem = function(props) {
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var items = props.items;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, _objectSpread({}, props, {
                toggleCollapse: function() {
                    return setOpen(!open);
                },
                open: open
            })),
            (items === null || items === void 0 ? void 0 : items.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Collapse, {
                theme: {
                    collapse: 'duration-500'
                },
                isOpened: open,
                children: items.map(function(item) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ListItem, _objectSpread({}, item, {
                        child: true
                    }), item.id);
                })
            }) : null
        ]
    }));
};

// EXTERNAL MODULE: ../core/src/components/CloseButton.tsx
var CloseButton = __webpack_require__(97872);
// EXTERNAL MODULE: ../graphql/src/generated/index.ts + 11 modules
var generated = __webpack_require__(63575);
;// CONCATENATED MODULE: ../core/src/components/Maps/Controls/LayersControl/SideMenu.tsx







function SideMenu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SideMenu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SideMenu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SideMenu_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SideMenu_templateObject() {
    var data = SideMenu_taggedTemplateLiteral([
        "\n  absolute\n  top-0\n  bottom-0\n  left-0\n  w-80\n  bg-white\n  z-[200]\n  overflow-scroll\n"
    ]);
    SideMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SideMenu_templateObject1() {
    var data = SideMenu_taggedTemplateLiteral([
        "\n  border-b-2\n  border-gray-400\n  bg-white\n  h-9\n  flex-1\n  flex\n  justify-between\n  items-center\n  px-2\n  font-semibold\n"
    ]);
    SideMenu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SideMenu_templateObject2() {
    var data = SideMenu_taggedTemplateLiteral([
        "border-r border-b-2 border-gray-400 w-[37px]"
    ]);
    SideMenu_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var Container = dist_default().div(SideMenu_templateObject());
var SideMenu_Line = dist_default().div(SideMenu_templateObject1());
var Box = dist_default().div(SideMenu_templateObject2());
var forestGroupTitles = Object.values(generated/* ForestGroupTitle */.PMI).filter(function(value) {
    return value !== 'II';
});
var SideMenu = function(param) {
    var onClose = param.onClose, className = param.className;
    var t = (0,esm/* useTranslation */.$G)('common').t;
    var items = (0,react.useMemo)(function() {
        return [
            {
                title: t('map.cadastralPlots'),
                id: 'cadastralPlots'
            },
            {
                title: t('map.taxonomicPlots'),
                id: 'taxonomicPlots'
            },
            {
                title: t('map.forestGroups'),
                id: 'forestGroups',
                items: forestGroupTitles.map(function(title) {
                    return {
                        id: title,
                        title: title
                    };
                })
            },
            {
                title: t('map.forestHabitats'),
                id: 'forestHabitats'
            }, 
        ];
    }, [
        t
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SideMenu_Line, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t('map.layers')
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* CloseButton */.P, {
                                    onClick: onClose
                                })
                            ]
                        })
                    ]
                }),
                items.map(function(item) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(NestedListItem, SideMenu_objectSpread({}, item), item.id);
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ../core/src/components/Maps/utils.ts
var utils = __webpack_require__(36886);
// EXTERNAL MODULE: ../core/src/components/Maps/Layers/VectorGrid.tsx
var VectorGrid = __webpack_require__(62381);
// EXTERNAL MODULE: ../core/src/config/api.js
var api = __webpack_require__(91673);
var api_default = /*#__PURE__*/__webpack_require__.n(api);
;// CONCATENATED MODULE: ../core/src/components/Maps/Layers/CadastralPlotsLayer.tsx







function CadastralPlotsLayer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CadastralPlotsLayer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CadastralPlotsLayer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var layerName = 'cadastralPlots';
var layerSource = 'cadastral_grid';
var options = {
    zIndex: 3,
    interactive: false,
    rendererFactory: leaflet_src.canvas.tile,
    vectorTileLayerStyles: CadastralPlotsLayer_defineProperty({}, layerSource, CadastralPlotsLayer_objectSpread({}, Object.values((0,utils/* buildVectorTileLayerDefaultOptions */.C)(layerName, layerSource).vectorTileLayerStyles)[0], {
        fill: false
    }))
};
var url = "".concat((api_default()).host, "/vector_tiles/").concat(layerSource, "/{z}/{x}/{y}.pbf");
var CadastralPlotsLayer = function() {
    var selected = (0,react.useContext)(Layers/* default */.Z).selected;
    return selected.includes(layerName) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VectorGrid/* VectorGrid */.f, {
        url: url,
        options: options
    }) : null;
};

// EXTERNAL MODULE: ../core/src/components/Maps/Popups/TaxonomicPlotPopup.tsx
var TaxonomicPlotPopup = __webpack_require__(26186);
// EXTERNAL MODULE: ../core/src/components/Maps/hooks.ts
var Maps_hooks = __webpack_require__(26610);
;// CONCATENATED MODULE: ../core/src/components/Maps/Layers/TaxonomicPlotsLayer.tsx








function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function TaxonomicPlotsLayer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function TaxonomicPlotsLayer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TaxonomicPlotsLayer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var TaxonomicPlotsLayer_layerName = 'taxonomicPlots';
var TaxonomicPlotsLayer_layerSource = 'stand_grid';
var vectorGridProps = {
    options: {
        zIndex: 4,
        vectorTileLayerStyles: TaxonomicPlotsLayer_defineProperty({}, TaxonomicPlotsLayer_layerSource, TaxonomicPlotsLayer_objectSpread({}, Object.values((0,utils/* buildVectorTileLayerDefaultOptions */.C)(TaxonomicPlotsLayer_layerName, TaxonomicPlotsLayer_layerSource).vectorTileLayerStyles)[0], {
            fillOpacity: 0
        }))
    },
    url: "".concat((api_default()).host, "/vector_tiles/").concat(TaxonomicPlotsLayer_layerSource, "/{z}/{x}/{y}.pbf"),
    activeStyles: {
        fillOpacity: 0,
        weight: 4
    }
};
var TaxonomicPlotsLayer = function() {
    var selected = (0,react.useContext)(Layers/* default */.Z).selected;
    var active = selected.includes(TaxonomicPlotsLayer_layerName);
    var ref = _slicedToArray((0,Maps_hooks/* useLayerPopupHandler */.Q)(active), 2), popupProps = ref[0], handleClick = ref[1];
    return active ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VectorGrid/* VectorGrid */.f, TaxonomicPlotsLayer_objectSpread({}, vectorGridProps, {
                onClick: handleClick
            })),
            popupProps ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxonomicPlotPopup/* TaxonomicPlotPopup */.O, TaxonomicPlotsLayer_objectSpread({}, popupProps)) : null
        ]
    }) : null;
};

// EXTERNAL MODULE: ../core/src/components/Maps/Popups/LayerPopup.tsx
var LayerPopup = __webpack_require__(44638);
// EXTERNAL MODULE: ../core/src/utils/index.ts
var src_utils = __webpack_require__(75920);
;// CONCATENATED MODULE: ../core/src/components/Maps/Popups/ForestHabitatPopup.tsx






function ForestHabitatPopup_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ForestHabitatPopup_templateObject() {
    var data = ForestHabitatPopup_taggedTemplateLiteral([
        "flex gap-4"
    ]);
    ForestHabitatPopup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ForestHabitatPopup_templateObject1() {
    var data = ForestHabitatPopup_taggedTemplateLiteral([
        "flex flex-col justify-between gap-4"
    ]);
    ForestHabitatPopup_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var ForestHabitatPopup_Line = dist_default().div(ForestHabitatPopup_templateObject());
var Column = dist_default().div(ForestHabitatPopup_templateObject1());
var ForestHabitatPopup = function(param) {
    var position = param.position, id = param.id;
    var t = (0,esm/* useTranslation */.$G)([
        'forest',
        'common',
        'enum'
    ]).t;
    var data = (0,generated/* useForestHabitatQuery */.rMk)({
        variables: {
            id: id
        }
    }).data;
    var forestHabitat = data === null || data === void 0 ? void 0 : data.forestHabitat;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(LayerPopup/* LayerPopup */.K, {
        position: position,
        layer: "forestHabitats",
        title: t('common:map.forestHabitat'),
        children: forestHabitat ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ForestHabitatPopup_Line, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LayerPopup/* LayerPopup.Item */.K.Item, {
                            label: t('area'),
                            value: (0,src_utils/* formatArea */.rV)(forestHabitat.area)
                        }),
                        forestHabitat.category ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LayerPopup/* LayerPopup.Item */.K.Item, {
                            label: t('forestHabitat.category'),
                            value: t("enum:ForestHabitatCategory.".concat(forestHabitat.category))
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LayerPopup/* LayerPopup.Item */.K.Item, {
                            label: t('forestHabitat.kind'),
                            value: t("enum:ForestHabitatKind.".concat(forestHabitat.kind))
                        }),
                        forestHabitat.codes.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LayerPopup/* LayerPopup.Item */.K.Item, {
                            label: t('forestHabitat.codes'),
                            value: forestHabitat.codes.join(', ')
                        }) : null
                    ]
                })
            ]
        }) : null
    }));
};

;// CONCATENATED MODULE: ../core/src/components/Maps/Layers/ForestHabitatsLayer.tsx








function ForestHabitatsLayer_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ForestHabitatsLayer_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ForestHabitatsLayer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ForestHabitatsLayer_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ForestHabitatsLayer_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ForestHabitatsLayer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ForestHabitatsLayer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ForestHabitatsLayer_slicedToArray(arr, i) {
    return ForestHabitatsLayer_arrayWithHoles(arr) || ForestHabitatsLayer_iterableToArrayLimit(arr, i) || ForestHabitatsLayer_unsupportedIterableToArray(arr, i) || ForestHabitatsLayer_nonIterableRest();
}
function ForestHabitatsLayer_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ForestHabitatsLayer_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ForestHabitatsLayer_arrayLikeToArray(o, minLen);
}
var ForestHabitatsLayer_layerSource = 'protected_areas';
var ForestHabitatsLayer_layerName = 'forestHabitats';
var ForestHabitatsLayer_options = (0,utils/* buildVectorTileLayerDefaultOptions */.C)(ForestHabitatsLayer_layerName, ForestHabitatsLayer_layerSource, {
    zIndex: 1
});
var ForestHabitatsLayer_url = "".concat((api_default()).host, "/vector_tiles/").concat(ForestHabitatsLayer_layerSource, "/{z}/{x}/{y}.pbf");
var ForestHabitatsLayer = function() {
    var selected = (0,react.useContext)(Layers/* default */.Z).selected;
    var active = selected.includes(ForestHabitatsLayer_layerName);
    var ref = ForestHabitatsLayer_slicedToArray((0,Maps_hooks/* useLayerPopupHandler */.Q)(active), 2), popupProps = ref[0], handleClick = ref[1];
    return active ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VectorGrid/* VectorGrid */.f, {
                url: ForestHabitatsLayer_url,
                options: ForestHabitatsLayer_options,
                onClick: handleClick
            }),
            popupProps ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ForestHabitatPopup, ForestHabitatsLayer_objectSpread({}, popupProps)) : null
        ]
    }) : null;
};

// EXTERNAL MODULE: ../../node_modules/lodash/capitalize.js
var capitalize = __webpack_require__(82108);
var capitalize_default = /*#__PURE__*/__webpack_require__.n(capitalize);
;// CONCATENATED MODULE: ../core/src/components/Maps/Popups/ForestGroupPopup.tsx





var ForestGroupPopup = function(param) {
    var position = param.position, id = param.id;
    var t = (0,esm/* useTranslation */.$G)([
        'forest',
        'common'
    ]).t;
    var data = (0,generated/* useForestGroupQuery */.ZiL)({
        variables: {
            id: id
        }
    }).data;
    var forestGroup = data === null || data === void 0 ? void 0 : data.forestGroup;
    return forestGroup ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LayerPopup/* LayerPopup */.K, {
        position: position,
        layer: forestGroup.title,
        title: t('common:map.forestGroup'),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LayerPopup/* LayerPopup.Item */.K.Item, {
            label: capitalize_default()(t('forestGroups')),
            value: t("enum:ForestGroupTitle.".concat(forestGroup.title.replace(' ', '')))
        })
    }) : null;
};

;// CONCATENATED MODULE: ../core/src/components/Maps/Layers/ForestGroupsLayer.tsx









function ForestGroupsLayer_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ForestGroupsLayer_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ForestGroupsLayer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ForestGroupsLayer_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ForestGroupsLayer_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ForestGroupsLayer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ForestGroupsLayer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ForestGroupsLayer_slicedToArray(arr, i) {
    return ForestGroupsLayer_arrayWithHoles(arr) || ForestGroupsLayer_iterableToArrayLimit(arr, i) || ForestGroupsLayer_unsupportedIterableToArray(arr, i) || ForestGroupsLayer_nonIterableRest();
}
function ForestGroupsLayer_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ForestGroupsLayer_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ForestGroupsLayer_arrayLikeToArray(o, minLen);
}
var ForestGroupsLayer_layerSource = 'forest_groups';
var ForestGroupsLayer_options = {
    zIndex: 2,
    vectorTileLayerStyles: ForestGroupsLayer_defineProperty({}, ForestGroupsLayer_layerSource, function(properties) {
        return Object.values((0,utils/* buildVectorTileLayerDefaultOptions */.C)(properties.title, ForestGroupsLayer_layerSource).vectorTileLayerStyles)[0];
    })
};
var ForestGroupsLayer = function() {
    var selected = (0,react.useContext)(Layers/* default */.Z).selected;
    var selectedTitles = forestGroupTitles.filter(function(title) {
        return selected.includes(title);
    }).map(function(title) {
        return "title[]=".concat(title);
    }).join('&');
    var ref = ForestGroupsLayer_slicedToArray((0,Maps_hooks/* useLayerPopupHandler */.Q)(!!selectedTitles), 2), popupProps = ref[0], handleClick = ref[1];
    return selectedTitles ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VectorGrid/* VectorGrid */.f, {
                url: "".concat((api_default()).host, "/vector_tiles/").concat(ForestGroupsLayer_layerSource, "/{z}/{x}/{y}.pbf?").concat(selectedTitles),
                options: ForestGroupsLayer_options,
                onClick: handleClick
            }),
            popupProps ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ForestGroupPopup, ForestGroupsLayer_objectSpread({}, popupProps)) : null
        ]
    }) : null;
};

;// CONCATENATED MODULE: ../assets/icons/layers.svg
var layers_path;

function layers_extends() { layers_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return layers_extends.apply(this, arguments); }



var SvgLayers = function SvgLayers(props) {
  return /*#__PURE__*/react.createElement("svg", layers_extends({
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), layers_path || (layers_path = /*#__PURE__*/react.createElement("path", {
    d: "M9.28 11.564c.199 0 .398-.032.6-.097.202-.065.424-.166.668-.303l6.906-4.018c.404-.236.69-.457.857-.662.167-.205.25-.441.25-.708 0-.266-.083-.5-.25-.702-.168-.201-.453-.42-.857-.656L10.548.4A3.077 3.077 0 0 0 9.88.09 2.066 2.066 0 0 0 9.28 0c-.197 0-.397.03-.598.091A2.86 2.86 0 0 0 8.024.4L1.107 4.418c-.403.236-.688.455-.856.656A1.066 1.066 0 0 0 0 5.776c0 .267.084.503.251.708.168.205.453.426.856.662l6.918 4.018c.236.137.455.238.656.303.202.065.402.097.6.097Zm0-1.792a.936.936 0 0 1-.422-.126L2.192 5.833c-.03-.015-.046-.034-.046-.057s.015-.042.046-.057l6.666-3.801c.16-.092.301-.137.423-.137.13 0 .27.045.422.137l6.667 3.801c.03.015.046.034.046.057s-.016.042-.046.057L9.703 9.646a.887.887 0 0 1-.422.126Zm0 6.164c.183 0 .357-.038.52-.114.164-.076.348-.175.554-.297l7.683-4.555c.182-.114.315-.249.4-.405a.973.973 0 0 0 .125-.462.847.847 0 0 0-.194-.548 1.345 1.345 0 0 0-.411-.354l-8.31 4.817a1.456 1.456 0 0 1-.195.092.49.49 0 0 1-.171.034.445.445 0 0 1-.166-.034 1.676 1.676 0 0 1-.188-.092L.605 9.201a1.345 1.345 0 0 0-.41.354.847.847 0 0 0-.195.548c0 .152.044.308.131.468.088.16.223.293.406.4l7.682 4.554c.206.122.39.22.554.297.163.076.333.114.508.114Zm0 4.064c.183 0 .357-.038.52-.114.164-.076.348-.175.554-.297l7.683-4.566c.175-.107.306-.238.393-.394a.94.94 0 0 0 .132-.462c0-.213-.065-.4-.194-.56a1.205 1.205 0 0 0-.411-.342l-8.31 4.806c-.07.038-.134.07-.195.097a.43.43 0 0 1-.171.04.391.391 0 0 1-.166-.04 3.044 3.044 0 0 1-.188-.097L.605 13.265a1.204 1.204 0 0 0-.41.342.863.863 0 0 0-.195.56.94.94 0 0 0 .131.462c.088.156.223.287.406.394l7.682 4.566c.206.122.39.22.554.297.163.076.333.114.508.114Z",
    fill: "#014152"
  })));
};

/* harmony default export */ var icons_layers = (SvgLayers);
;// CONCATENATED MODULE: ../core/src/components/Maps/Controls/LayersControl/index.tsx











var controlContainer = leaflet_src.DomUtil.create('div');
var LeafletLayerControl = leaflet_src.Control.extend({
    onAdd: function onAdd() {
        leaflet_src.DomEvent.disableClickPropagation(controlContainer);
        leaflet_src.DomEvent.disableScrollPropagation(controlContainer);
        return controlContainer;
    }
});
var LayersControl = function(param) {
    var _position = param.position, position = _position === void 0 ? 'topleft' : _position;
    var map = (0,hooks/* useMap */.Sx)();
    var ref = (0,react.useState)(false), menuOpen = ref[0], setMenuOpen = ref[1];
    var toggleMenu = (0,react.useCallback)(function() {
        return setMenuOpen(function(flag) {
            return !flag;
        });
    }, []);
    (0,react.useEffect)(function() {
        var control = new LeafletLayerControl({
            position: position
        });
        map.addControl(control);
        var closeMenu = function() {
            return setMenuOpen(false);
        };
        map.on('exitFullscreen', closeMenu);
        return function() {
            map.removeControl(control);
            map.off('exitFullscreen', closeMenu);
        };
    }, [
        map,
        position
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ForestGroupsLayer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CadastralPlotsLayer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxonomicPlotsLayer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ForestHabitatsLayer, {}),
            /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "leaflet-bar",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "cursor-pointer",
                        onClick: toggleMenu,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_layers, {
                            width: 19,
                            height: 20
                        })
                    }),
                    menuOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenu, {
                        onClose: toggleMenu
                    }) : null
                ]
            }), controlContainer)
        ]
    }));
};


/***/ }),

/***/ 92689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ MapModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15623);
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(leaflet__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28316);
/* harmony import */ var react_leaflet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89507);
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27581);






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var controlContainer = leaflet__WEBPACK_IMPORTED_MODULE_2__.DomUtil.create('div');
var LeafletControl = leaflet__WEBPACK_IMPORTED_MODULE_2__.Control.extend({
    onAdd: function onAdd() {
        leaflet__WEBPACK_IMPORTED_MODULE_2__.DomEvent.disableClickPropagation(controlContainer);
        leaflet__WEBPACK_IMPORTED_MODULE_2__.DomEvent.disableScrollPropagation(controlContainer);
        return controlContainer;
    }
});
var MapModal = function(_param) {
    var children = _param.children, props = _objectWithoutProperties(_param, [
        "children"
    ]);
    var map = (0,react_leaflet__WEBPACK_IMPORTED_MODULE_4__/* .useMap */ .Sx)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var control = new LeafletControl();
        map.addControl(control);
        return function() {
            map.removeControl(control);
        };
    }, [
        map
    ]);
    return(/*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_3__.createPortal)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Modal__WEBPACK_IMPORTED_MODULE_5__/* .Modal */ .u, _objectSpread({}, props, {
        children: children
    })), controlContainer));
};



/***/ }),

/***/ 87593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ FitMap; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_leaflet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89507);


var FitMap = function(param) {
    var bounds = param.bounds, _boundsOptions = param.boundsOptions, boundsOptions = _boundsOptions === void 0 ? {
        paddingTopLeft: [
            10,
            60
        ],
        paddingBottomRight: [
            10,
            60
        ]
    } : _boundsOptions;
    var map = (0,react_leaflet__WEBPACK_IMPORTED_MODULE_1__/* .useMap */ .Sx)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (bounds) {
            map.fitBounds(bounds, boundsOptions);
            map.fire('fitBounds');
        }
    }, [
        map,
        bounds,
        boundsOptions
    ]);
    return null;
};


/***/ }),

/***/ 52889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ DeflateLayer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15623);
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(leaflet__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_leaflet_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(78794);
/* harmony import */ var react_dom_server__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48090);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(46487);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75920);
/* harmony import */ var _Marker__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67472);
/* harmony import */ var Leaflet_Deflate_src_L_Deflate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8872);
/* harmony import */ var Leaflet_Deflate_src_L_Deflate__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(Leaflet_Deflate_src_L_Deflate__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var leaflet_markercluster_dist_leaflet_markercluster__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31151);
/* harmony import */ var leaflet_markercluster_dist_leaflet_markercluster__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(leaflet_markercluster_dist_leaflet_markercluster__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var leaflet_markercluster_dist_MarkerCluster_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46829);
/* harmony import */ var leaflet_markercluster_dist_MarkerCluster_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(leaflet_markercluster_dist_MarkerCluster_css__WEBPACK_IMPORTED_MODULE_6__);











function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  w-8\n  y-8\n  text-center\n  font-sans\n  font-semibold\n  ml-1\n  mt-1\n  rounded-2xl\n  bg-secondary-500\n  leading-[32px]\n  text-white\n  hover:bg-secondary-600\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  p-2\n  inline-block\n  bg-secondary-500\n  hover:bg-secondary-600\n  active:bg-secondary-700\n  rounded-lg\n  translate-y-[-11px]\n  -translate-x-2/4\n  ml-2\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Cluster = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default().div(_templateObject());
var Price = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default().div(_templateObject1());
var AuctionPrice = function(param) {
    var highestBidObject = param.highestBidObject, startingBid = param.startingBid;
    var price = highestBidObject ? highestBidObject.price : startingBid;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Price, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            className: "text-white font-semibold",
            children: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatMoney */ .lb)(price)
        })
    }));
};
var markerOptions = function(param) {
    var feature = param.feature;
    if (feature === null || feature === void 0 ? void 0 : feature.properties.id) {
        return {
            icon: (0,leaflet__WEBPACK_IMPORTED_MODULE_1__.divIcon)({
                html: (0,react_dom_server__WEBPACK_IMPORTED_MODULE_2__.renderToStaticMarkup)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AuctionPrice, _objectSpread({}, feature.properties)))
            })
        };
    }
    return {
        icon: _Marker__WEBPACK_IMPORTED_MODULE_8__.icon
    };
};
var DeflateLayer = (0,_react_leaflet_core__WEBPACK_IMPORTED_MODULE_9__/* .createPathComponent */ .Au)(function(_param, context) {
    var _minSize = _param.minSize, minSize = _minSize === void 0 ? 30 : _minSize, props = _objectWithoutProperties(_param, [
        "minSize"
    ]);
    var markerLayer = (0,leaflet__WEBPACK_IMPORTED_MODULE_1__.markerClusterGroup)({
        zoomToBoundsOnClick: false,
        maxClusterRadius: 60,
        iconCreateFunction: function(cluster) {
            return new leaflet__WEBPACK_IMPORTED_MODULE_1__.DivIcon({
                html: (0,react_dom_server__WEBPACK_IMPORTED_MODULE_2__.renderToString)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Cluster, {
                    children: cluster.getChildCount()
                })),
                className: 'cluster',
                iconSize: new leaflet__WEBPACK_IMPORTED_MODULE_1__.Point(40, 40)
            });
        },
        polygonOptions: {
            fillColor: (_config__WEBPACK_IMPORTED_MODULE_10___default().colors.secondary[500]),
            color: (_config__WEBPACK_IMPORTED_MODULE_10___default().colors.secondary[500])
        }
    });
    markerLayer.on('clusterclick', function(event) {
        var clusterBounds = event.propagatedFrom.getBounds();
        var polygonBounds = layerContainer.getLayers().map(function(layer) {
            if (!('getBounds' in layer)) return;
            var bounds = layer.getBounds();
            return (0,leaflet__WEBPACK_IMPORTED_MODULE_1__.latLngBounds)(bounds.getSouthWest(), bounds.getNorthEast());
        }).filter(function(bounds) {
            return bounds ? bounds.intersects(clusterBounds) : false;
        }).reduce(function(layerBounds, bounds) {
            return layerBounds.extend(bounds);
        });
        context.map.fitBounds(polygonBounds, {
            padding: [
                20,
                20
            ]
        });
    });
    var layerContainer = (0,leaflet__WEBPACK_IMPORTED_MODULE_1__.deflate)(_objectSpread({
        minSize: minSize,
        markerLayer: markerLayer,
        markerOptions: markerOptions
    }, props));
    return {
        instance: layerContainer,
        context: _objectSpread({}, context, {
            layerContainer: layerContainer
        })
    };
});



/***/ }),

/***/ 33724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ LayerGeoJSON; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63964);
/* harmony import */ var react_leaflet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57820);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46487);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_0__);



function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var colors = (_config__WEBPACK_IMPORTED_MODULE_0___default().colors);
var ref, ref1, ref2, ref3;
var LayerGeoJSON = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(react_leaflet__WEBPACK_IMPORTED_MODULE_2__/* .GeoJSON */ .Q).attrs(function(param) {
    var color = param.color, _intensity = param.intensity, intensity = _intensity === void 0 ? 500 : _intensity;
    var ref5, ref4;
    return {
        style: {
            color: (ref1 = (ref = (ref5 = colors[color]) === null || ref5 === void 0 ? void 0 : ref5[intensity]) !== null && ref !== void 0 ? ref : colors[color]) !== null && ref1 !== void 0 ? ref1 : color,
            fillColor: (ref3 = (ref2 = (ref4 = colors[color]) === null || ref4 === void 0 ? void 0 : ref4[intensity]) !== null && ref2 !== void 0 ? ref2 : colors[color]) !== null && ref3 !== void 0 ? ref3 : color
        }
    };
}).withConfig({
    componentId: "sc-95b4f36a-0"
})(_templateObject());


/***/ }),

/***/ 63025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ TaxonomicPlotIntersectionLayer; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-leaflet/esm/hooks.js
var hooks = __webpack_require__(89507);
// EXTERNAL MODULE: ../../node_modules/react-leaflet/esm/Pane.js + 1 modules
var Pane = __webpack_require__(79637);
// EXTERNAL MODULE: ../core/src/components/Maps/utils.ts
var utils = __webpack_require__(36886);
// EXTERNAL MODULE: ../core/src/contexts/Layers.tsx
var Layers = __webpack_require__(95106);
// EXTERNAL MODULE: ../core/src/components/Maps/Popups/TaxonomicPlotPopup.tsx
var TaxonomicPlotPopup = __webpack_require__(26186);
// EXTERNAL MODULE: ../core/src/components/Maps/Layers/VectorGrid.tsx
var VectorGrid = __webpack_require__(62381);
// EXTERNAL MODULE: ../core/src/config/api.js
var api = __webpack_require__(91673);
var api_default = /*#__PURE__*/__webpack_require__.n(api);
// EXTERNAL MODULE: ../../node_modules/react-leaflet/esm/Tooltip.js
var Tooltip = __webpack_require__(93764);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63964);
// EXTERNAL MODULE: ../../node_modules/react-leaflet/esm/GeoJSON.js
var GeoJSON = __webpack_require__(57820);
// EXTERNAL MODULE: ../../node_modules/react-fast-compare/index.js
var react_fast_compare = __webpack_require__(78435);
var react_fast_compare_default = /*#__PURE__*/__webpack_require__.n(react_fast_compare);
// EXTERNAL MODULE: ../core/src/utils/cartography.ts
var cartography = __webpack_require__(19371);
// EXTERNAL MODULE: ../core/src/config/theme.js
var theme = __webpack_require__(46487);
var theme_default = /*#__PURE__*/__webpack_require__.n(theme);
;// CONCATENATED MODULE: ../core/src/components/Maps/Layers/FeatureLabel.tsx








function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    background-color: transparent;\n    border: none;\n    box-shadow: none;\n    color: ",
        ";\n    font-weight: 700;\n    text-shadow: ",
        " 0px 0px 2px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var TransparentTooltip = (0,styled_components_browser_esm/* default */.ZP)(Tooltip/* Tooltip */.u).withConfig({
    componentId: "sc-2892121d-0"
})(_templateObject(), (theme_default()).colors.white, (theme_default()).colors.black);
var FeatureLabel = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var label = _param.label, feature = _param.feature, props = _objectWithoutProperties(_param, [
        "label",
        "feature"
    ]);
    var positions = (0,cartography/* geoJSONPolylabelPositions */.um)(feature.geometry);
    var data = {
        type: 'Polygon',
        coordinates: [
            positions
        ]
    };
    return positions.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GeoJSON/* GeoJSON */.Q, {
        data: data,
        children: positions.map(function(position, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(TransparentTooltip, _objectSpread({
                permanent: true,
                position: position,
                direction: "center"
            }, props, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: label
                })
            }), index);
        })
    }) : null;
}, (react_fast_compare_default()));


// EXTERNAL MODULE: ../core/src/components/Maps/hooks.ts
var Maps_hooks = __webpack_require__(26610);
;// CONCATENATED MODULE: ../core/src/components/Maps/Layers/TaxonomicPlotsIntersectionLayer.tsx










function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function TaxonomicPlotsIntersectionLayer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function TaxonomicPlotsIntersectionLayer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TaxonomicPlotsIntersectionLayer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var layerPane = {
    name: 'taxonomicPlotIntersection',
    zoomThreshold: 12,
    style: {
        zIndex: 500
    }
};
var labelPane = {
    name: 'taxonomicPlotIntersectionLabel',
    zoomThreshold: 15,
    style: {
        zIndex: 510
    }
};
var layerName = 'taxonomicPlots';
var layerSource = 'cadastral_stands';
var vectorGridProps = {
    options: {
        pane: layerPane.name,
        vectorTileLayerStyles: TaxonomicPlotsIntersectionLayer_defineProperty({}, layerSource, TaxonomicPlotsIntersectionLayer_objectSpread({}, Object.values((0,utils/* buildVectorTileLayerDefaultOptions */.C)(layerName, layerSource).vectorTileLayerStyles)[0], {
            fillOpacity: 0,
            weight: 1
        })),
        getFeatureId: function(param) {
            var properties = param.properties;
            return properties.taxonomic_plot_id;
        }
    },
    activeStyles: {
        fillOpacity: 0,
        weight: 4
    }
};
var TaxonomicPlotIntersectionLayer = /*#__PURE__*/ (0,react.memo)(function(param1) {
    var cadastralPlots = param1.cadastralPlots, labelsVisible = param1.labelsVisible;
    var ref;
    var selected = (0,react.useContext)(Layers/* default */.Z).selected;
    var map = (0,hooks/* useMap */.Sx)();
    var ref1 = (0,react.useState)([]), features = ref1[0], setFeatures = ref1[1];
    var setPaneVisibility = (0,react.useCallback)(function() {
        var zoom = map.getZoom();
        var togglePane = function(param) {
            var name = param.name, zoomThreshold = param.zoomThreshold;
            var pane = map.getPane(name);
            if (pane) {
                var style = pane.style;
                var visibility = zoom >= zoomThreshold ? 'visible' : 'hidden';
                if (style.visibility !== visibility) {
                    style.visibility = visibility;
                }
            }
        };
        togglePane(labelPane);
    }, [
        map
    ]);
    (0,react.useEffect)(function() {
        map.on('zoomend fitBounds', setPaneVisibility);
        return function() {
            map.off('zoomend fitBounds', setPaneVisibility);
        };
    }, [
        map,
        setPaneVisibility
    ]);
    var selectedIds = cadastralPlots.map(function(param) {
        var id = param.id;
        return "id[]=".concat(id);
    }).join('&');
    var active = selected.includes(layerName);
    var ref2 = _slicedToArray((0,Maps_hooks/* useLayerPopupHandler */.Q)(active, (ref = vectorGridProps.options) === null || ref === void 0 ? void 0 : ref.getFeatureId), 2), popupProps = ref2[0], handleClick = ref2[1];
    return active ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pane/* Pane */.X, {
                name: labelPane.name,
                style: labelPane.style,
                children: features.map(function(feature) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(FeatureLabel, {
                        label: feature.properties.stand_number,
                        feature: feature
                    }, feature.properties.stand_number);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pane/* Pane */.X, {
                name: layerPane.name,
                style: layerPane.style
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VectorGrid/* VectorGrid */.f, TaxonomicPlotsIntersectionLayer_objectSpread({}, vectorGridProps, {
                url: "".concat((api_default()).host, "/vector_tiles/").concat(layerSource, "/{z}/{x}/{y}.pbf?").concat(selectedIds),
                onFeatureLoad: labelsVisible ? setFeatures : null,
                onClick: handleClick
            })),
            popupProps ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxonomicPlotPopup/* TaxonomicPlotPopup */.O, TaxonomicPlotsIntersectionLayer_objectSpread({}, popupProps)) : null
        ]
    }) : null;
});


/***/ }),

/***/ 62381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ VectorGrid; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _react_leaflet_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78794);
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15623);
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(leaflet__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _turf_union__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6616);
/* harmony import */ var _turf_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20755);
/* harmony import */ var leaflet_vectorgrid_src_Leaflet_VectorGrid_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27462);
/* harmony import */ var leaflet_vectorgrid_src_Leaflet_VectorGrid_Protobuf_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94812);
/* harmony import */ var leaflet_vectorgrid_src_Leaflet_Renderer_Canvas_Tile_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31753);
/* harmony import */ var leaflet_vectorgrid_src_Leaflet_Renderer_Canvas_Tile_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(leaflet_vectorgrid_src_Leaflet_Renderer_Canvas_Tile_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var leaflet_vectorgrid_src_Leaflet_Renderer_SVG_Tile_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97383);
/* harmony import */ var leaflet_vectorgrid_src_Leaflet_Renderer_SVG_Tile_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(leaflet_vectorgrid_src_Leaflet_Renderer_SVG_Tile_js__WEBPACK_IMPORTED_MODULE_7__);









function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var _acc;
var defaultOptions = {
    rendererFactory: (leaflet__WEBPACK_IMPORTED_MODULE_1___default().svg.tile),
    subdomains: 'abcd',
    interactive: true,
    getFeatureId: function(param) {
        var properties = param.properties;
        return properties.id;
    }
};
var VectorGrid = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)((0,_react_leaflet_core__WEBPACK_IMPORTED_MODULE_8__/* .createLayerComponent */ .dW)(function(param1, context) {
    var url = param1.url, options = param1.options, onClick = param1.onClick, onFeatureLoad = param1.onFeatureLoad, filter = param1.filter, _activeStyles = param1.activeStyles, activeStyles = _activeStyles === void 0 ? {} : _activeStyles;
    var protobufOptions = _objectSpread({}, defaultOptions, options);
    var instance = leaflet__WEBPACK_IMPORTED_MODULE_1___default().vectorGrid.protobuf(url, protobufOptions);
    var getFeatureId = protobufOptions.getFeatureId;
    instance.on('mouseover', function(param) {
        var propagatedFrom = param.propagatedFrom;
        var ref;
        var defaultStyle = options === null || options === void 0 ? void 0 : (ref = options.vectorTileLayerStyles) === null || ref === void 0 ? void 0 : ref[instance.getDataLayerNames()[0]];
        instance.setFeatureStyle(getFeatureId(propagatedFrom), _objectSpread({}, typeof defaultStyle === 'function' ? defaultStyle(propagatedFrom.properties, context.map.getZoom()) : defaultStyle, {
            fillOpacity: 0.6,
            opacity: 0.8
        }, activeStyles));
    });
    instance.on('mouseout', function(param) {
        var propagatedFrom = param.propagatedFrom;
        return instance.resetFeatureStyle(getFeatureId(propagatedFrom));
    });
    if (onClick) {
        instance.on('click', onClick);
    }
    if (filter) {
        instance.setFilter(filter);
    }
    if (onFeatureLoad) {
        instance.on('load', function(event) {
            var map = context.map;
            var zoom = map.getZoom().toString();
            var tiles = Object.entries(event.target._vectorTiles).filter(function(param) {
                var _param = _slicedToArray(param, 1), key = _param[0];
                var ref = _slicedToArray(key.split(':'), 3), z = ref[2];
                return z === zoom;
            }).map(function(param) {
                var _param = _slicedToArray(param, 2), value = _param[1];
                return value;
            });
            var featureMap = tiles.reduce(function(acc, vectorTile) {
                Object.entries(vectorTile._features).forEach(function(param2) {
                    var _param = _slicedToArray(param2, 2), id = _param[0], features = _param[1];
                    var _id;
                    (_id = (_acc = acc)[id]) !== null && _id !== void 0 ? _id : _acc[id] = {
                        properties: features[0].feature.properties,
                        points: []
                    };
                    var points = features.map(function(param3) {
                        var feature = param3.feature;
                        return feature._parts.map(function(part) {
                            return part.map(function(param) {
                                var x = param.x, y = param.y;
                                var origin = map.latLngToLayerPoint(event.target._tileCoordsToNwSe(vectorTile._tileCoord)[0]);
                                var latLng = map.layerPointToLatLng(new leaflet__WEBPACK_IMPORTED_MODULE_1__.Point(x + origin.x, y + origin.y));
                                return [
                                    latLng.lng,
                                    latLng.lat
                                ];
                            });
                        });
                    });
                    acc[id].points = acc[id].points.concat(points);
                });
                return acc;
            }, {});
            onFeatureLoad(Object.values(featureMap).map(function(param) {
                var properties = param.properties, points = param.points;
                return _objectSpread({}, points.map(function(_points) {
                    return (0,_turf_helpers__WEBPACK_IMPORTED_MODULE_3__/* .polygon */ .yu)(_points);
                }).reduce(function(_unionPolygon, _polygon) {
                    return (0,_turf_union__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_unionPolygon, _polygon);
                }), {
                    properties: properties
                });
            }));
        });
    }
    return {
        instance: instance,
        context: context
    };
}, function(instance, param) {
    var filter = param.filter, onClick = param.onClick, url = param.url;
    if (onClick) {
        instance.on('click', onClick);
    }
    if (filter) {
        instance.setFilter(filter);
    }
    if (url) {
        instance.setUrl(url);
    }
}));


/***/ }),

/***/ 67472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Maps_Marker; },
  "icon": function() { return /* binding */ icon; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/leaflet/dist/leaflet-src.js
var leaflet_src = __webpack_require__(15623);
// EXTERNAL MODULE: ../../node_modules/react-leaflet/esm/Marker.js
var Marker = __webpack_require__(94053);
// EXTERNAL MODULE: ../../node_modules/react-dom/server.browser.js
var server_browser = __webpack_require__(48090);
// EXTERNAL MODULE: ../core/src/components/Maps/Popups/index.tsx
var Popups = __webpack_require__(26421);
;// CONCATENATED MODULE: ../assets/icons/location-gold.svg
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgLocationGold = function SvgLocationGold(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M44.625 21.25c0 14.875-19.125 27.625-19.125 27.625S6.375 36.125 6.375 21.25a19.125 19.125 0 0 1 38.25 0Z",
    fill: "#D9B310"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M25.5 27.625a6.375 6.375 0 1 0 0-12.75 6.375 6.375 0 0 0 0 12.75Z",
    fill: "#87700D"
  })));
};

/* harmony default export */ var location_gold = (SvgLocationGold);
;// CONCATENATED MODULE: ../core/src/components/Maps/Marker.tsx







var iconUrl = 'data:image/svg+xml,' + encodeURIComponent((0,server_browser.renderToStaticMarkup)(/*#__PURE__*/ (0,jsx_runtime.jsx)(location_gold, {
    width: 51,
    height: 51
})));
var icon = (0,leaflet_src.icon)({
    iconUrl: iconUrl,
    iconRetinaUrl: iconUrl,
    iconSize: [
        51,
        51
    ],
    className: 'filter drop-shadow-marker',
    iconAnchor: [
        25.5,
        51
    ],
    popupAnchor: [
        0,
        -25.5
    ]
});
var addLineBreaks = function(content) {
    return content.split('\n').map(function(text, index) {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                text,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
            ]
        }, "".concat(text, "-").concat(index));
    });
};
var Marker_Marker = function(param) {
    var position = param.position, popup = param.popup;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Marker/* Marker */.J, {
        icon: icon,
        position: position,
        children: popup && /*#__PURE__*/ (0,jsx_runtime.jsx)(Popups/* Popup */.G, {
            children: addLineBreaks(popup)
        })
    }));
};
/* harmony default export */ var Maps_Marker = (Marker_Marker);


/***/ }),

/***/ 44638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ LayerPopup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _Controls_LayersControl_LayerIdentifier__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98836);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26421);



var Item = function(param) {
    var label = param.label, value = param.value, className = param.className;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col ".concat(className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-gray-700 text-xs leading-5 uppercase",
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-sm leading-6",
                children: value
            })
        ]
    }));
};
var LayerPopup = function(param) {
    var position = param.position, layer = param.layer, title = param.title, children = param.children;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_1__/* .Popup */ .G, {
        position: position,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex gap-2 items-center mr-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Controls_LayersControl_LayerIdentifier__WEBPACK_IMPORTED_MODULE_2__/* .LayerIdentifier */ .X, {
                            $id: layer
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-sm",
                            children: title
                        })
                    ]
                }),
                children
            ]
        })
    });
};
LayerPopup.Item = Item;


/***/ }),

/***/ 26186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ TaxonomicPlotPopup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33052);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_capitalize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82108);
/* harmony import */ var lodash_capitalize__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_capitalize__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36573);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75920);
/* harmony import */ var _LayerPopup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44638);
/* harmony import */ var _foros_fe_graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63575);
/* harmony import */ var _Controls_MapModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92689);










function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "text-2xl text-center mb-6 font-medium"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "flex justify-between gap-4"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Title = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default().p(_templateObject());
var Line = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default().div(_templateObject1());
var TaxonomicPlotPopup = function(param) {
    var position = param.position, id = param.id, cadastralPlotId = param.cadastralPlotId;
    var ref;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)([
        'forest',
        'auctions',
        'common'
    ]).t;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), modalOpen = ref1[0], setModalOpen = ref1[1];
    var toggleModal = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return setModalOpen(function(flag) {
            return !flag;
        });
    }, []);
    var ref2 = (0,_foros_fe_graphql__WEBPACK_IMPORTED_MODULE_5__/* .usePopupTaxonomicPlotQuery */ .nUG)({
        variables: {
            id: id,
            cadastralPlotId: cadastralPlotId
        }
    }), popupData = ref2.data;
    var ref3 = (0,_foros_fe_graphql__WEBPACK_IMPORTED_MODULE_5__/* .useModalTaxonomicPlotQuery */ .PQF)({
        variables: {
            id: id,
            cadastralPlotId: cadastralPlotId
        },
        skip: !modalOpen
    }), modalData = ref3.data;
    var popupTaxonomicPlot = popupData === null || popupData === void 0 ? void 0 : popupData.taxonomicPlot;
    var modalTaxonomicPlot = modalData === null || modalData === void 0 ? void 0 : modalData.taxonomicPlot;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LayerPopup__WEBPACK_IMPORTED_MODULE_6__/* .LayerPopup */ .K, {
                position: position,
                layer: "taxonomicPlots",
                title: t('common:map.taxonomicPlot'),
                children: popupTaxonomicPlot ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Line, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LayerPopup__WEBPACK_IMPORTED_MODULE_6__/* .LayerPopup.Item */ .K.Item, {
                                    label: t('taxonomicPlot.identifier'),
                                    value: popupTaxonomicPlot.mapIdentifier
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LayerPopup__WEBPACK_IMPORTED_MODULE_6__/* .LayerPopup.Item */ .K.Item, {
                                    label: t('area'),
                                    value: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatArea */ .rV)(popupTaxonomicPlot.area)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Line, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LayerPopup__WEBPACK_IMPORTED_MODULE_6__/* .LayerPopup.Item */ .K.Item, {
                                    label: t('taxonomicPlot.composition'),
                                    value: popupTaxonomicPlot.speciesComposition
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LayerPopup__WEBPACK_IMPORTED_MODULE_6__/* .LayerPopup.Item */ .K.Item, {
                                    label: t('taxonomicPlot.age'),
                                    value: popupTaxonomicPlot.age ? t('common:years', {
                                        count: popupTaxonomicPlot.age
                                    }) : null
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .z, {
                            title: t('auctions:showMore'),
                            value: "taxonomic-plot-popup-more",
                            onClick: toggleModal
                        })
                    ]
                }) : null
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Controls_MapModal__WEBPACK_IMPORTED_MODULE_9__/* .MapModal */ .V, {
                open: modalOpen,
                onClose: toggleModal,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                        children: t('common:map.taxonomicPlot')
                    }),
                    modalTaxonomicPlot ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "grid grid-cols-3 gap-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LayerPopup__WEBPACK_IMPORTED_MODULE_6__/* .LayerPopup.Item */ .K.Item, {
                                label: t('taxonomicPlot.identifier'),
                                value: modalTaxonomicPlot.mapIdentifier
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LayerPopup__WEBPACK_IMPORTED_MODULE_6__/* .LayerPopup.Item */ .K.Item, {
                                label: t('taxonomicPlot.composition'),
                                value: modalTaxonomicPlot.speciesComposition
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LayerPopup__WEBPACK_IMPORTED_MODULE_6__/* .LayerPopup.Item */ .K.Item, {
                                label: t('area'),
                                value: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatArea */ .rV)(modalTaxonomicPlot.area)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LayerPopup__WEBPACK_IMPORTED_MODULE_6__/* .LayerPopup.Item */ .K.Item, {
                                label: "".concat(lodash_capitalize__WEBPACK_IMPORTED_MODULE_4___default()(t('auctions:volume')), ", ").concat(t('common:cubicMeters')),
                                value: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatVolume */ .fP)(modalTaxonomicPlot.volume, '')
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LayerPopup__WEBPACK_IMPORTED_MODULE_6__/* .LayerPopup.Item */ .K.Item, {
                                label: t('marketValue'),
                                value: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatValueMoney */ .J3)(modalTaxonomicPlot.marketValue)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LayerPopup__WEBPACK_IMPORTED_MODULE_6__/* .LayerPopup.Item */ .K.Item, {
                                label: t('totalValue'),
                                value: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatValueMoney */ .J3)(modalTaxonomicPlot.totalValue)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LayerPopup__WEBPACK_IMPORTED_MODULE_6__/* .LayerPopup.Item */ .K.Item, {
                                label: t('taxonomicPlot.crownDensity'),
                                value: modalTaxonomicPlot.crownDensity
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LayerPopup__WEBPACK_IMPORTED_MODULE_6__/* .LayerPopup.Item */ .K.Item, {
                                label: "".concat(lodash_capitalize__WEBPACK_IMPORTED_MODULE_4___default()(t('auctions:volume')), ", ").concat(t('common:cubicMeters'), "/").concat(t('common:hectare')),
                                value: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatVolume */ .fP)(modalTaxonomicPlot.volumePerHa, '')
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LayerPopup__WEBPACK_IMPORTED_MODULE_6__/* .LayerPopup.Item */ .K.Item, {
                                label: t('taxonomicPlot.growingPlace'),
                                value: modalTaxonomicPlot.growingPlace
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LayerPopup__WEBPACK_IMPORTED_MODULE_6__/* .LayerPopup.Item */ .K.Item, {
                                label: lodash_capitalize__WEBPACK_IMPORTED_MODULE_4___default()(t('forestGroups')),
                                value: ((ref = modalTaxonomicPlot.forestGroups) === null || ref === void 0 ? void 0 : ref.length) ? modalTaxonomicPlot.forestGroups.join(', ') : t('notSpecified')
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LayerPopup__WEBPACK_IMPORTED_MODULE_6__/* .LayerPopup.Item */ .K.Item, {
                                label: t('taxonomicPlot.age'),
                                value: modalTaxonomicPlot.age ? t('common:years', {
                                    count: modalTaxonomicPlot.age
                                }) : null
                            }),
                            modalTaxonomicPlot.forestHabitatPresence ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LayerPopup__WEBPACK_IMPORTED_MODULE_6__/* .LayerPopup.Item */ .K.Item, {
                                label: t('common:map.forestHabitat'),
                                value: t('common:yes')
                            }) : null
                        ]
                    }) : null
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 26421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ Popup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_leaflet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89507);
/* harmony import */ var react_leaflet__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26692);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97872);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Popup = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var children = _param.children, props = _objectWithoutProperties(_param, [
        "children"
    ]);
    var map = (0,react_leaflet__WEBPACK_IMPORTED_MODULE_2__/* .useMap */ .Sx)();
    var close = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return map.closePopup();
    }, [
        map
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_leaflet__WEBPACK_IMPORTED_MODULE_3__/* .Popup */ .G, _objectSpread({
        pane: "popupPane",
        autoPanPadding: [
            60,
            10
        ],
        closeButton: false
    }, props, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_4__/* .CloseButton */ .P, {
                className: "absolute top-1 right-1",
                onClick: close
            }),
            children
        ]
    })));
});



/***/ }),

/***/ 26610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useLayerPopupHandler; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function useLayerPopupHandler(active) {
    var getFeatureId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(param) {
        var properties = param.properties;
        return properties.id;
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), popupProps = ref[0], setPopupProps = ref[1];
    var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var propagatedFrom = param.propagatedFrom, latlng = param.latlng;
        return setPopupProps({
            id: getFeatureId(propagatedFrom),
            position: latlng
        });
    }, [
        getFeatureId
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!active) {
            setPopupProps(null);
        }
    }, [
        active
    ]);
    return [
        popupProps,
        handleClick
    ];
}


/***/ }),

/***/ 36886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ getLayerColor; },
/* harmony export */   "C": function() { return /* binding */ buildVectorTileLayerDefaultOptions; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var layersColors = {
    cadastralPlots: '#d62a23',
    taxonomicPlots: '#a1b48d',
    I: '#FF3535',
    IIA: '#FF9F1A',
    IIB: '#FFFE56',
    III: '#FF5FFF',
    IV: '#D9FFDC',
    forestHabitats: '#86E4FA'
};
function getLayerColor(name) {
    return layersColors[name] || '#123456';
}
function buildVectorTileLayerDefaultOptions(layerName, layerSource, options) {
    return _objectSpread({
        vectorTileLayerStyles: _defineProperty({}, layerSource, {
            color: getLayerColor(layerName),
            opacity: 0.5,
            fill: true,
            fillColor: getLayerColor(layerName),
            fillOpacity: 0.2,
            weight: 1
        })
    }, options);
}


/***/ }),

/***/ 95106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ LayersContextProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var initialState = {
    selected: [
        'cadastralPlots',
        'taxonomicPlots'
    ],
    toggleSelected: function() {}
};
var Context = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(initialState);
/* harmony default export */ __webpack_exports__["Z"] = (Context);
var LayersContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialState), state = ref[0], setState = ref[1];
    var value = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var toggleSelected = function(values) {
            var selected = state.selected;
            var newSelected = selected.some(function(s) {
                return values.includes(s);
            }) ? selected.filter(function(v) {
                return !values.includes(v);
            }) : _toConsumableArray(selected).concat(_toConsumableArray(values));
            setState(_objectSpread({}, state, {
                selected: newSelected
            }));
        };
        return _objectSpread({}, state, {
            toggleSelected: toggleSelected
        });
    }, [
        state
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Context.Provider, {
        value: value,
        children: children
    }));
};


/***/ }),

/***/ 19371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n5": function() { return /* binding */ getCadastralPlotCenter; },
/* harmony export */   "gP": function() { return /* binding */ cadastralPlotsToGeoJSONData; },
/* harmony export */   "lL": function() { return /* binding */ googleDirectionsURL; },
/* harmony export */   "um": function() { return /* binding */ geoJSONPolylabelPositions; }
/* harmony export */ });
/* unused harmony exports polygonStringsToGeoJSONData, stringToWktInstance, wktPolygonToBounds, polygonPolylabelPosition */
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15623);
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(leaflet__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var wicket_wicket_leaflet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53467);
/* harmony import */ var wicket_wicket_leaflet__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(wicket_wicket_leaflet__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var polylabel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54670);
/* harmony import */ var polylabel__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(polylabel__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _turf_area__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26350);
/* harmony import */ var _turf_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20755);





function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var minimumLabelablePolygonArea = 100;
function polygonStringsToGeoJSONData(polygonArray) {
    var polygons = polygonArray.filter(function(item) {
        return !!item;
    });
    if (!polygons.length) {
        return [
            ,
            []
        ];
    }
    var wktPolygons = polygons.map(stringToWktInstance);
    var geoJSON = wktPolygons.map(function(wktPolygon) {
        return wktPolygon.toJson();
    });
    return [
        wktPolygonToBounds(wktPolygons.reduce(function(rootWktPolygon, wktPolygon) {
            return rootWktPolygon.merge(wktPolygon);
        })),
        geoJSON, 
    ];
}
function getCadastralPlotCenter(cadastralPlot) {
    if (!cadastralPlot) return;
    var boundary = cadastralPlot.boundary, latitude = cadastralPlot.latitude, longitude = cadastralPlot.longitude;
    var bounds;
    if (boundary) {
        bounds = wktPolygonToBounds(stringToWktInstance(boundary));
    } else if (latitude && longitude) {
        bounds = new leaflet__WEBPACK_IMPORTED_MODULE_0__.LatLngBounds([
            [
                latitude,
                longitude
            ]
        ]);
    }
    return bounds === null || bounds === void 0 ? void 0 : bounds.getCenter();
}
function stringToWktInstance(polygon1) {
    return new (wicket_wicket_leaflet__WEBPACK_IMPORTED_MODULE_1___default().Wkt)(polygon1);
}
function wktPolygonToBounds(wktPolygon) {
    return wktPolygon.toObject().getBounds();
}
function cadastralPlotsToGeoJSONData(cadastralPlots) {
    var ref = _slicedToArray(polygonStringsToGeoJSONData(cadastralPlots.map(function(param) {
        var boundary = param.boundary;
        return boundary;
    })), 2), boundaryBounds = ref[0], boundaryGeoJSON = ref[1];
    var latLonArray = cadastralPlots.filter(function(param) {
        var boundary = param.boundary, latitude = param.latitude, longitude = param.longitude;
        return !boundary && latitude && longitude;
    }).map(function(param) {
        var latitude = param.latitude, longitude = param.longitude;
        return [
            latitude,
            longitude
        ];
    });
    var ref1 = [
        latLonArray.length ? new leaflet__WEBPACK_IMPORTED_MODULE_0__.Polyline(latLonArray).getBounds() : undefined,
        latLonArray.map(function(latlon) {
            return new leaflet__WEBPACK_IMPORTED_MODULE_0__.Polygon([
                latlon
            ]).toGeoJSON().geometry;
        }), 
    ], latLonBounds = ref1[0], latLongGeoJSON = ref1[1];
    return [
        boundaryBounds && latLonBounds ? boundaryBounds.extend(latLonBounds) : boundaryBounds || latLonBounds,
        _toConsumableArray(boundaryGeoJSON).concat(_toConsumableArray(latLongGeoJSON)), 
    ];
}
function googleDirectionsURL(coords) {
    var point = (0,leaflet__WEBPACK_IMPORTED_MODULE_0__.latLng)(coords);
    return "https://www.google.com/maps/dir/?api=1&origin=&destination=".concat(point.lat, ",").concat(point.lng, "&travelmode=driving&dir_action=navigate");
}
function geoJSONPolylabelPositions(feature) {
    var polygons = feature.type === 'Polygon' ? [
        feature.coordinates
    ] : feature.coordinates;
    return polygons.filter(function(coords) {
        return (0,_turf_area__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_turf_helpers__WEBPACK_IMPORTED_MODULE_4__/* .polygon */ .yu)(coords)) >= minimumLabelablePolygonArea;
    }).map(polygonPolylabelPosition);
}
function polygonPolylabelPosition(coords) {
    var ref = _slicedToArray(polylabel__WEBPACK_IMPORTED_MODULE_2___default()(coords), 2), lng = ref[0], lat = ref[1];
    return [
        lat,
        lng
    ];
}


/***/ })

}]);